import { render, staticRenderFns } from "./PostureList.vue?vue&type=template&id=74f4e32a&scoped=true&"
import script from "./PostureList.vue?vue&type=script&lang=js&"
export * from "./PostureList.vue?vue&type=script&lang=js&"
import style0 from "./PostureList.vue?vue&type=style&index=0&id=74f4e32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4e32a",
  null
  
)

export default component.exports